import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className='footer_main'>
            <img src='/images/footer_logo.svg' alt='' />

            <p>Cactus Jack Foundation • info@cactusjack.foundation</p>
        </div>
    )
}

export default Footer
